import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { specials } from "@/mocks/specials";
import { getTitleById } from "@/lib/titles";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Reveal from "@/components/base/Reveal";

export default function SpecialList() {
  useSeo({
    title: "专题合集 - WW我的快乐在哪里影视专题",
    description:
      "WW我的快乐在哪里精选影视专题合集，按悬疑、治愈、科幻、权谋等主题打包片单，帮你快速找到想看的内容。",
    keywords: "影视专题,片单推荐,合集,WW我的快乐在哪里,剧情介绍",
    path: "https://91zytv.asia/special",
  });

  return (
    <section className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "专题合集" }]} />

      <header className="mt-5 max-w-3xl">
        <h1 className="text-2xl font-black text-foreground-950 md:text-3xl">专题合集</h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          我们按主题把影视作品重新打包，从悬疑烧脑到冬日治愈，从华语科幻到权谋博弈，
          每个专题都配有推荐语与梳理好的片单，帮你更快做决定。
        </p>
      </header>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        {specials.map((special, index) => (
          <Reveal key={special.id} delay={index * 70}>
            <Link
              to={`/special/${special.id}`}
              className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200">
                <img
                  src={special.cover}
                  alt={`${special.name} 专题主图`}
                  title={`${special.name} - WW我的快乐在哪里专题合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
                  {special.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h2 className="text-xl font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {special.name}
                </h2>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">{special.intro}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {special.titleIds.slice(0, 4).map((id) => {
                    const item = getTitleById(id);
                    if (!item) return null;
                    return (
                      <span
                        key={id}
                        className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800"
                      >
                        {item.name}
                      </span>
                    );
                  })}
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  查看专题片单
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}